export default __webpack_public_path__ + "static/media/investment2.e1d8fbb5.png";